<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tSDdT7/media/FC-9781035844517.jpg?1718732527005" alt="This image is the cover for the book Blue"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blue
      </h1>
      <p class="bookDescription body article font2">
        <p>From the late fifties to the present-day, Harriet’s story is one of bereavement and loss, and how she lives through them to a fulfilled and happy old age. Losing her brother and then her father at a young age, she is obliged to run the family farm and consequently does not pursue the career she might have had. She gives up ideas of studying History of Art at university and accepts the loss of opportunity as she resigns herself to following her mother’s advice to be happy being ‘just a wife and mother.’ She settles into a contented marriage to steady Sam and as times change them and their lives, she expresses her love of beauty and colour in designing gardens. Harriet never relinquishes her love of art and when time allows, she begins to study Medieval painting, specialising in the early Italian Renaissance. She escapes into a world of lapis lazuli blue, aquamarine, cerulean, cobalt blue, and azure. And here she finds a guide in James who is so knowledgeable, so charming and so attractive… Thus, Harriet moves from the lost idyllic rural landscapes of her youth to the fantasy ‘hortus conclusus’ of medieval Madonnas. And beside her is James, party to this beautiful fantasy.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christine Barwell
      </h2>
      
      <p class="authorDescription body article">Growing up on a farm and then travelling the world was the subject of Christine’s autobiography, Changing Skies. In Blue, she draws on these experiences to create a world where a life may be lived in more than one way. She lives in Sussex now.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02e2b32e